import AlertBar from 'views/molecules/alertbar/AlertBar';

export default AlertBar;
